module.exports = __webpack_public_path__ + "img/pos_tich_diem.87d2904c.png";